import GraphQL from './ConsultaGraphQL';

import url from '../../../../../apiService/ApiUrl.js';

// JavaScript Document
function handleError(err, This){
	console.log(`Request failed: ${err}`);
	This.setState({
		loading: false,
		insertPlanoMensaje: {
			response: 'failure',
			mensaje: `Hubo un error, el error fué: ${err}, intenta de nuevo`
		}
	})
}

const newPlano = (This, data) => {
	const options = {
		method: 'POST',
		headers: {
			"Content-type": "application/json"
		},
		body: JSON.stringify(GraphQL(data)),
		credentials: 'include'
	}

	//llamada de datos con Fetch
	fetch(url, options)
	.then(res => res.json())
	.then( (res) => {
		
		//console.log(res)

		This.setState({
			loading: false,
			insertPlanoMensaje: {
				response: 'success',
				mensaje: res.data.insertPlano.mensaje
			}
		})

		This.props.dispatch({
			type: 'ADD_PLANO_TO_PLANOS',
			payload: {
				plano: {
					id: res.data.insertPlano.plano.id,
					nombreDePlano: res.data.insertPlano.plano.nombreDePlano,
					tipoPlano: res.data.insertPlano.plano.tipoPlano,
					fecha: new Date(parseInt(res.data.insertPlano.plano.fecha))
				},
				idProyecto: res.data.insertPlano.plano.idProyecto
			}
		})

		return res

	})
	.then(() => {
		setTimeout( () => {
			This.setState({
				insertPlanoMensaje: null
			}) 
		}, 3000);
	})
	.catch(err => handleError(err, This))
	.then(() => {
		setTimeout( () => {
			This.setState({
				insertPlanoMensaje: null
			}) 
		}, 3000);
	});

	//termina fetch
}

export default newPlano;
